// extracted by mini-css-extract-plugin
export default {"body":"_2RBaV","reminder":"SKpgX","personalList":"_15RTn","personalItem":"_3l7Fz"};